import queryString from 'query-string'
import { csrfRequest } from './helpers/request'
import { GENERIC_INVITATION_ERROR_CODE } from '../../constants/error.codes'

export const confirmInvitation = data =>
  csrfRequest({
    url: `/users/invitation/accept/${data.token}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: queryString.stringify(data)
  })
    .then(response => {
      if (response.status === 200) {
        return response.json().then(json => {
          return Promise.resolve(json)
        })
      } else if (response.status === 400) {
        return response.json().then(json => {
          return Promise.reject(new Error(json.code))
        })
      } else {
        return Promise.reject(new Error(GENERIC_INVITATION_ERROR_CODE))
      }
    })
    .catch(error => {
      throw error
    })
